import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";

export function SendPageView(title = document.title) {
  const location = window.location;
  logEvent(analytics, "page_view", {
    page_title: document.title + " - manual_send",
    page_location: window.location.href,
    page_path: location.pathname + location.search,
  });
}

export function SendAnalyticsEvent(eventName, params = {}) {
  const location = window.location;
  logEvent(analytics, eventName, {
    ...params,
    page_title: document.title + " - manual_send",
    page_location: window.location.href,
    page_path: location.pathname + location.search,
  });
}

export function SendBeginCheckout(uid, raceName) {
  const location = window.location;
  logEvent(analytics, "begin_checkout", {
    uid: uid,
    raceName: raceName,
    page_title: document.title + " - manual_send",
    page_location: window.location.href,
    page_path: location.pathname + location.search,
  });
}

export function SendCheckoutProgress(uid, raceName, checkoutStep, stepName, item) {
  const location = window.location;
  logEvent(analytics, "checkout_progress", {
    uid: uid,
    raceName: raceName,
    checkout_step: checkoutStep,
    step_name: stepName,
    page_title: document.title + " - manual_send",
    page_location: window.location.href,
    page_path: location.pathname + location.search,
  });
}
export function SendRegistration(uid, raceName, legName) {
  const location = window.location;
  logEvent(analytics, "registration_b", {
    uid: uid,
    raceName: raceName,
    legName: legName,
    page_title: document.title + " - manual_send",
    page_location: window.location.href,
    page_path: location.pathname + location.search,
  });
}
